var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7881 2.34963L13.1103 0.135275C12.8644 -0.0686748 12.4991 -0.0386388 12.2899 0.202608L0.941398 13.2794C0.876208 13.3545 0.831942 13.4444 0.81102 13.541L0.0127339 17.293C-0.0339676 17.5131 0.0499496 17.7406 0.228975 17.8782C0.334053 17.9588 0.46054 18 0.588234 18C0.678231 18 0.768957 17.9794 0.852148 17.9375L4.25968 16.2311C4.32705 16.1974 4.38738 16.1511 4.43724 16.0947L15.8536 3.18717C15.9587 3.06848 16.011 2.91249 15.9981 2.75481C15.9859 2.59712 15.9103 2.45107 15.7879 2.34982L15.7881 2.34963ZM3.63016 15.2361L1.41694 16.3442L1.93066 13.9315L10.9702 3.51482L12.7505 4.9245L3.63016 15.2361ZM13.4854 4.09329L11.6971 2.67728L12.8027 1.40321L14.5712 2.86547L13.4854 4.09329Z",
    fill: "#363636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.f04be4696a247ff5a6029a8236753f10.svg";
export { ForwardRef as ReactComponent };